<template>
  <Chatbot
    :is-disabled="isDisabled"
    :disabled-message="disabledMessage"
  />
</template>


<script>
// import SubComponent from '../components/SubComponent'
import Chatbot from '@frontend/ui/features/chat/components/Chatbot.vue';
import { mapStores } from 'pinia';
import { useChatStore } from '@frontend/ui/stores/chatStore';

export default {
  name: 'ChatbotWrapper',
  components: { Chatbot },
  props: ['context', 'isDisabled', 'disabledMessage', 'socketPath'],
  data() {
    return { /* Local variables */ };
  },
  computed: {
    ...mapStores(useChatStore),
  },
  watch: { /*
    Watches an existing property
    Only runs when the watched property changes */
  },
  async created() {
    await this.chatStore.createSocket(this.socketPath || '/ws/agent-chat/');
    // await this.chatStore.createConversation();
    console.log('THIS IS THE SOCKET', this.chatStore.socket);
  },
  methods: {},
};
</script>


<style scoped>

</style>
